import { createPortal } from 'react-dom';
import React, { useState, useEffect } from 'react';
import { toISODateOrNull, formatDateForDateInput } from '../../utils/dateUtils';
import './NoteForm.css';
import { onayla } from '../../utils/onayla';

const NoteForm = ({ note, onSubmit, onCancel, onDelete, loading }) => {
  const [formData, setFormData] = useState({
    Title: '',
    Content: '',
    NoteDate: ''
  });

  useEffect(() => {
    if (note) {
      setFormData({
        Title: note.Title || note.title || '',
        Content: note.Content || note.content || '',
        NoteDate: formatDateForDateInput(note.NoteDate || note.noteDate)
      });
    }
  }, [note]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.Title.trim()) {
      alert('Başlık boş olamaz!');
      return;
    }

    if (!formData.Content.trim()) {
      alert('İçerik boş olamaz!');
      return;
    }

    onSubmit({
      Title: formData.Title.trim(),
      Content: formData.Content.trim(),
      NoteDate: toISODateOrNull(formData.NoteDate)
    });
  };

  /* PENCERE HER ZAMAN EN UST KATMANDA (document.body'ye tasinir).
     Bu form baska bir pencerenin icinden de aciliyor (yeni dosya formu ->
     "Masraf Ekle" / "Not Ekle"). Ic ice kalinca, distaki pencere hareketli
     (transform) oldugunda "position: fixed" ekrana degil o pencereye gore
     yerlesiyor ve form gorunmez kalabiliyordu (2026-10-03: "masraf ekle
     tikliyorum acilmiyor"). Olaylar React agacinda eskisi gibi akar. */
  return createPortal(
    <div className="note-form-overlay" onClick={(e) => {
      if (e.target.classList.contains('note-form-overlay')) {
        onCancel();
      }
    }}>
      <div className="note-form-container" onClick={(e) => e.stopPropagation()}>
        <div className="note-form-header">
          <h2>{note ? 'Notu Düzenle' : 'Yeni Not Oluştur'}</h2>
          <button className="btn btn-secondary" onClick={onCancel}>
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="note-form">
          <div className="form-group">
            <label>Başlık *</label>
            <input
              type="text"
              name="Title"
              value={formData.Title}
              onChange={handleChange}
              className="form-control"
              placeholder="Not başlığı"
              required
            />
          </div>

          <div className="form-group">
            <label>İçerik *</label>
            <textarea
              name="Content"
              value={formData.Content}
              onChange={handleChange}
              className="form-control"
              rows="6"
              placeholder="Not içeriği"
              required
            />
          </div>

          <div className="form-group">
            <label>Tarih (Opsiyonel)</label>
            <input
              type="date"
              name="NoteDate"
              value={formData.NoteDate}
              onChange={handleChange}
              className="form-control"
            />
            <small className="form-text text-muted">
              Tarih belirtirseniz, bu tarih takvimde sarı renkte görünecektir.
            </small>
          </div>

          <div className="form-actions">
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div>
                {note && onDelete && (
                  <button 
                    type="button" 
                    onClick={async () => {
                      if (await onayla('Bu notu silmek istediğinize emin misiniz?')) {
                        await onDelete();
                      }
                    }} 
                    className="btn btn-danger"
                    disabled={loading}
                  >
                    Sil
                  </button>
                )}
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="button" onClick={onCancel} className="btn btn-secondary">
                  İptal
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Kaydediliyor...' : (note ? 'Güncelle' : 'Oluştur')}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  , document.body);
};

export default NoteForm;

